import Page from "Pages/_Layouts/DefaultInternal";
import useGetMetadata from "customHooks/useGetMetadata";
import { useTranslation } from "react-i18next";
import Loading from "customHooks/useCompleoReactHookForm/helpers/Loading";
import FormClassic from "customHooks/useCompleoReactHookForm/components/FormClassic";
import { useApi } from "customHooks/useApi";
import { useCancelButtonForm } from "customHooks/useCancelButtonForm";
import useValuesFromSource from "customHooks/useValuesFromSource";
import useCustomLists from "./components/useCustomLists";
import { usePlanLimitsPage } from "customHooks/usePlanLimits/usePlanLimits";
import useCompleoReactHookForm, {
    useCompleoReactHookFormGetMainData
} from "customHooks/useCompleoReactHookForm";
import useFieldsToHide from "./components/useFieldsToHide";

const CareersSettingsNew = (props: any) => {
    const cancelFunction = useCancelButtonForm("/careers");
    const moduleName = "CAREERSSETTINGSNEW";
    const [t, i18n, readyTranslation] = useTranslation(moduleName, {
        useSuspense: false
    });
    const postAddress = `/careerssettings/new`;
    const [customLists, readyLists] = useCustomLists();

    const [addDataReturn, addData] = useApi(postAddress, "post");
    const [metadata] = useGetMetadata(moduleName);
    const [valuesFromSource] = useValuesFromSource(metadata, true, {
        defaultApplicationForm: true,
        main: false
    });
    const { limitReached } = usePlanLimitsPage(t, "/careers", "addCareersSite");
    const reactHookFormMethods = useCompleoReactHookFormGetMainData({
        t,
        ready: readyTranslation && readyLists,
        i18nV: i18n,
        metadadosRetorno: metadata,
        valuesFromSource: valuesFromSource
    });
    const { watch } = reactHookFormMethods.reactHookFormMethods;

    const { fieldsToHide } = useFieldsToHide(
        watch,
        readyTranslation && readyLists
    );

    const [formCompleo, finished] = useCompleoReactHookForm({
        t,
        ready: readyTranslation && readyLists,
        i18nV: i18n,
        postMethod: !limitReached ? addData : undefined,
        postReturn: addDataReturn,
        redirectAddress: "/careers",
        FormType: FormClassic,
        metadadosRetorno: metadata,
        valuesFromSource: valuesFromSource,
        secondaryButtonFunction: cancelFunction,
        customLists: customLists,
        fieldsToHide: fieldsToHide,
        invalidateQueryClientItems: [
            "/careerssettings/careersbyjob",
            "/careerssettings/search",
            "/careerssettings/list"
        ],
        reactHookFormMethods: reactHookFormMethods
    });
    const ready = readyTranslation && finished && readyLists;

    let compRetorno: boolean | JSX.Element;
    compRetorno = <Loading />;

    if (ready) {
        compRetorno = formCompleo;
        return (
            <Page
                featureName={t("a_FeatureName")}
                featureMainDescription={t("a_FeatureMainDescription")}
                maxWidth="md"
            >
                {compRetorno}
            </Page>
        );
    } else {
        return <Page>{compRetorno}</Page>;
    }
};

export default CareersSettingsNew;
